module.exports = __webpack_public_path__ + "static/media/ic-list.74ad848a.svg";